import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '2019十大重庆经济年度人物、十大两江新区经济年度人物评选';

const route: RouteConfig = {
  path: '/20200409JJRW',
  name: 'JJRW',
  redirect: '/20200409JJRW/rules',
  component: () => import('./Home.vue'),
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'rules',
      component: () => import('./Rules.vue'),
      name: '20200409JJRW/rules',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      component: () => import('./News.vue'),
      name: '20200409JJRW/News',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'apply',
      component: () => import('./Apply.vue'),
      name: '20200409JJRW/apply',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'List',
      component: () => import('./List.vue'),
      name: '20200409JJRW/List',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Detail',
      component: () => import('./Detail.vue'),
      name: '20200409JJRW/Detail',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
